<template>
  <div
    class="base_custom_switch"
    :class="flexDirection"
    v-show="currThemeObj.cssStyle"
    :style="{
      '--mixtmt_whiteColor': currThemeObj.cssStyle.whiteColor,
      '--mixtmt_greyColor2': currThemeObj.cssStyle.greyColor2,
      '--mixtmt_greyColor6': currThemeObj.cssStyle.greyColor6,
      '--mixtmt_greyColor7': currThemeObj.cssStyle.greyColor7,
      '--mixtmt_mainColor6': currThemeObj.cssStyle.mainColor6,
    }"
  >
    <div class="switch_main">
      <span
        v-for="item in data"
        :key="item.id"
        :class="['switch_item', item.act ? 'act' : '']"
        @click="clickSwitch(item)"
      >
        <i></i>
        <span class="switch_item_name" v-text="item.name"></span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'base_custom_switch',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return [
          //   {
          //     id: 'matchDate',
          //     name: '按日期查看',
          //     act: true,
          //   },
          //   {
          //     id: 'seriesCode',
          //     name: '按小组查看',
          //     act: false,
          //   },
        ]
      },
    },
    flexDirection: {
      // 默认是世界杯 上下结构；publicThemeDialog_switch：分享弹窗左右结构
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    clickSwitch(item) {
      this.$emit('clickSwitchEvent', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.base_custom_switch {
  position: relative;
  width: 10.07vw;
  height: 6.25vw;
  &.publicThemeDialog_switch {
    width: 16.8vw;
    height: 2.778vw;
    .switch_main {
      flex-direction: row;
      justify-content: space-between;
      height: 2.778vw;
      &::before {
        visibility: hidden;
      }
      .switch_item {
        .switch_item_name {
          padding-left: 0.556vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
  .switch_main {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 6.25vw;

    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 50%;
      z-index: 2;
      width: 1px;
      height: 3.47vw;
      transform: translateY(-50%);
      background-color: var(--mixtmt_greyColor7);
    }
    .switch_item {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      &.act i {
        position: relative;
        border: 1px solid var(--mixtmt_mainColor6);
        background-color: var(--mixtmt_whiteColor);
        &::before {
          content: '\20';
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          transform: translate(-50%, -50%);
          background-color: var(--mixtmt_mainColor6);
          width: 70%;
          height: 70%;
          border-radius: 50%;
          border: 15% solid var(--mixtmt_whiteColor);
        }
      }
      i {
        width: 1.111vw;
        height: 1.111vw;
        border-radius: 50%;
        border: 1px solid var(--mixtmt_greyColor6);
        background-color: var(--mixtmt_whiteColor);
      }
      .switch_item_name {
        padding-left: 0.69vw;
        font-size: 1.111vw;
        color: var(--mixtmt_greyColor2);
      }
    }
  }
}
.mixtmt_pc .base_custom_switch {
  .switch_main {
    .switch_item {
      cursor: pointer;
      &:hover {
        .switch_item_name {
          color: var(--mixtmt_mainColor6);
        }
      }
    }
  }
}
</style>
